import React from 'react';
import { Link } from 'react-router-dom';

const ManagerDashboardPage = () => {
    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>ManagerDashboardPage</h1>
            <nav style={{ marginTop: '20px' }}>
                <Link to="/">Home</Link> | <Link to="/login">Login</Link> | <Link to="/register">Register</Link>
            </nav>
            <h1><Link to="/test1">test1</Link></h1>
            <h1><Link to="/test2">test2</Link></h1>
            <h1><Link to="/test3">test3</Link></h1>
            <h1><Link to="/test4/53">test4</Link></h1>
            <h1><Link to="/test5">test5</Link></h1>
        </div>
    );
};

export default ManagerDashboardPage;
